/**
 *  @class
 *  @function ThemeFooter
 */

if (!customElements.get('theme-footer')) {
  class ThemeFooter extends HTMLElement {
    constructor() {
      super();
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.accordions = this.querySelectorAll('details');

      // Call onResize directly to set initial state based on window size
      this.onResize();

      // Add resize event listener
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      // Remove resize event listener when element is removed
      window.removeEventListener('resize', this.onResize);
    }

    onResize() {
      this.accordions.forEach((accordion) => {
        if (window.innerWidth > 768) {
          accordion.setAttribute('open', '');
        } else {
          accordion.removeAttribute('open');
        }
      });
    }
  }

  customElements.define('theme-footer', ThemeFooter);
}

// Newsletter form handling
document.addEventListener('DOMContentLoaded', function() {
  const newsletterForms = document.querySelectorAll('form[action*="contact"]');
  
  newsletterForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      // Form validation
      const emailInput = form.querySelector('input[name="contact[email]"]');
      if (!emailInput || !emailInput.value) {
        e.preventDefault();
        return;
      }
      
      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailInput.value)) {
        e.preventDefault();
        return;
      }
    });
  });

  // Auto-hide newsletter messages after 5 seconds
  function autoHideMessages() {
    const successMessages = document.querySelectorAll('.newsletter-success');
    const errorMessages = document.querySelectorAll('.newsletter-error');
    
    function hideMessage(message) {
      setTimeout(() => {
        message.classList.add('fade-out');
        setTimeout(() => {
          if (message.parentNode) {
            message.parentNode.removeChild(message);
          }
        }, 300);
      }, 5000);
    }
    
    successMessages.forEach(hideMessage);
    errorMessages.forEach(hideMessage);
  }
  
  // Run auto-hide function
  autoHideMessages();
});
